var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconCheckmark = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["size", "className"]);
    return (_jsx("span", __assign({ className: "mex-icon mex-icon--".concat(size, " ").concat(className) }, props, { children: _jsxs("svg", __assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_1_295)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.6919 7.82406C27.2818 7.41402 26.617 7.41401 26.207 7.82404L13 21.0301L5.79393 13.8239C5.38388 13.4139 4.71906 13.4139 4.309 13.8239C3.89896 14.234 3.89895 14.8988 4.309 15.3089L11.515 22.515L11.5148 22.5151C11.5805 22.5808 11.6134 22.6137 11.6422 22.6403C11.7464 22.7366 11.8582 22.8198 11.9756 22.8898C12.7224 23.3362 13.6956 23.2531 14.3581 22.6407C14.3869 22.614 14.4198 22.5812 14.4854 22.5156L14.4849 22.515L27.6919 9.30902C28.1019 8.89897 28.1019 8.23412 27.6919 7.82406Z" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_1_295" }, { children: _jsx("rect", { width: "32", height: "32", fill: "white" }) })) })] })) })));
};
export default IconCheckmark;
